module.exports = {
    openGraphImage: 'https://www.autotrader.com/cm-api/content/static/img/icon/logos/atc-logo-160x40.png',
    openGraphSiteName: 'Autotrader',
    openGraphType: 'website',
};
